import type { InteractionBlueprintData } from "../contentParsers/interactionBlueprintSchema";

export const cloneBlueprintForRedux = (
  data: InteractionBlueprintData,
): InteractionBlueprintData =>
  JSON.parse(JSON.stringify(data)) as InteractionBlueprintData;
